export const settleCn = {
    ruzhuliucheng:"入驻流程",
    tijiaoziliao:"提交资料",
    ziliaoContent:"等待资质审核（1-3个工作日）审核通过，短信签约",
    shenqingqianyue:"申请签约",
    qianyueContent:"填写公司信息，上传机构营业执照，填写您的收款信息，方便结算",
    ruzhuchenggong:"入驻成功",
    ruzhuContent:"录入信息 平台审核，审核通过即可营业",
    ruzhuyaoqiu:"入驻要求",
    zhengshu:"证书",
    jigouzhengjian:'机构证件',
    gongsishili:"公司实力",
    womendeyoushi:"我们的优势",
    tybzrz:"通用标准认证",
    tyContent:"全行业质量管理体系解决方案",
    jcjgqdndjr:'检测机构期待您的加入',
    joinNow:"立即加入"
}


// WEBPACK FOOTER //
// ./src/lang/home/settle/indexCn.js